import React from "react";

const Footer = () => {
  return (
    <footer>
      <h6>
        Designed and created by{" "}
        <a href="https://www.linkedin.com/in/laurenleighcolvin/">
          Lauren Colvin
        </a>
      </h6>
      <h6>
        All data sourced from:{" "}
        <a className="api-link" href="https://acnhapi.com/">
          Animal Crossing API
        </a>
      </h6>
    </footer>
  );
};

export default Footer;
